import * as yup from 'yup';
import { validate } from '../../../shared/utils/validation.utils';

const schema = yup.object().shape({
    currentPassword: yup.string()
        .required('The password is required'),
    newPassword: yup.string()
        .required('The password is required'),
    confirmPassword: yup.string()
        .oneOf([yup.ref('newPassword'), null, ''], 'The password confirmation does not match')
        .required('The password confirmation is required'),
});

export const validateUpdatePassword = data => validate(schema, data, {
    convert: true,
    abortEarly: false,
});
